"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*_\-.?])[A-Za-z\d!@#$%^&*_\-.?]{8,20}$/);
